import { cn } from "@/lib/utils"

/**
 * The floating-pane treatment for panes sitting on the bg-sidebar canvas:
 * a card, rounded, with a hairline border.
 *
 * This started as a copy of ui/sidebar's SidebarInset (which cannot be reused
 * outside the sidebar's peer scope — its classes key off peer-data attributes
 * on the Sidebar element). It has since diverged: SidebarInset still separates
 * itself from the canvas with a soft shadow, where a pane takes a border, as
 * the brief editor's header and document cards do. Side panels (the assistant,
 * and whatever comes next) take the treatment from here, so a change to the
 * pane look is made once.
 *
 * Both are gated behind `md:` — below it a pane is full-bleed, and an edge
 * line against the viewport is not a card.
 */
export function InsetPane({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      className={cn("bg-background flex flex-col md:rounded-xl md:border", className)}
      {...props}
    />
  )
}
